module.exports = __webpack_public_path__ + "img/title_pic.6992bd0e.jpg";